var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block_wrap"},[_c('div',{staticClass:"available_roles"},[_c('p',{staticClass:"top"},[_vm._v(" "+_vm._s(_vm.translate("client.role_manager.available_roles"))+" ")]),_c('TableRole',{staticClass:"body",attrs:{"role_list":_vm.role_list,"permission_list":_vm.permission_list,"client_id":_vm.client_id}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }